<template>
  <div>
    <h4>Ban</h4>
    <template v-if="ban !== null">
      <table
        class="prop-table mb-4"
      >
        <tr>
          <th>Id</th>
          <td>{{ban.id}}</td>
        </tr>
        <tr>
          <th>Banner</th>
          <td>
            <user-link
              :user="getUser(ban.userId)"
            />
          </td>
        </tr>
        <tr>
          <th>Begin</th>
          <td>{{ban.ctime | getMomentMinStr}}</td>
        </tr>
        <tr>
          <th>Duration type</th>
          <td>{{getBanDurationTypeName}}</td>
        </tr>
        <tr v-if="isTemp">
          <th>Planned duration</th>
          <td>{{getPlannedDurationStr}}</td>
        </tr>
        <tr v-if="isTemp">
          <th>Planned end</th>
          <td>{{ban.ftime | getMomentMinStr}}</td>
        </tr>
      </table>

      <p class="prop-lable">Reason</p>
      <p>
        {{ban.reason}}
      </p>
    </template>

    <loading-indicator
      v-if="isLoading"
    />

  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';
import UserLink from './UserLink.vue';

import { getBanDurationTypeName as utilGetBanDurationTypeName } from '../model/player_ban.js';
import { convertUserArrayToMap   } from '../model/user';
import { getUserFromMap          } from '../model/user';
import { convertDurationSecToStr } from '../util';

export default {
  name: 'PlayerBan',

  components: {
    LoadingIndicator,
    UserLink,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    banId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      userMap: null,
      ban: null,
    };
  },

  computed: {
    getPlannedDuration() {
      return this.ban.ftime - this.ban.ctime;
    },

    getBanDurationTypeName() {
      return utilGetBanDurationTypeName(this.ban);
    },

    getPlannedDurationStr() {
      return convertDurationSecToStr(this.getPlannedDuration);
    },

    isTemp() {
      return this.ban.ftime > 0;
    },
  },

  created() {
    notifier.deleteSenderNotifications(this);

    this.isLoading = true;

    const url = `/player/${this.playerId}/ban/${this.banId}`;
    HTTP.get(url)
    .then(response => {
      this.isLoading = false;

      const data = response.data.data;
      if(data === null) {
        notifier.showError('Invalid server response. data === null.');
        return;
      }

      if('users' in data) {
        this.userMap = convertUserArrayToMap(data.users);
      }

      this.ban = data.ban;
    })
    .catch(e => {
      this.isLoading = false;
      notifier.showError(e.response.data, {sender: this});
    });
  },

  methods: {
    getUser(userId) {
      return getUserFromMap(this.userMap, userId);
    },
  },
};
</script>
